// bpm-frontend's NavBar built each dashboard's route the same way: lowercase, spaces -> underscores
// (e.g. "Omni ROAS" -> "omni_roas"). Keeping the same scheme here means existing bookmarked/shared
// bpm-frontend links keep working once this page is served by tinuiti-frontend.
//
// This is the only direction that's safe to compare on: reversing a slug back into a name (e.g.
// `slug.replace(/_/g, ' ')`) is lossy and non-injective — a name containing an underscore doesn't
// round-trip, and two names differing only by space-vs-underscore collide to the same slug. Always
// match by deriving the slug from the candidate name and comparing slugs, never by reversing.
export const customDashboardSlug = (name: string): string => name.toLowerCase().replace(/ /g, '_');
